var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "stores" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("block-breadcrumbs"),
        _c(
          "div",
          { staticClass: "head" },
          [
            _c("h1", { staticClass: "title" }, [
              _vm._v("\n        Адреса магазинов в городе\n        "),
              _c("span", { on: { click: _vm.changeCity } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.currentCity.name || _vm.CITY.name) +
                    "\n        "
                )
              ])
            ]),
            _vm.metroSpecs.length
              ? _c(
                  "div",
                  { staticClass: "select" },
                  [
                    _c("ui-select", {
                      attrs: {
                        value: _vm.metro,
                        options: _vm.sortedMetroSpecs,
                        "empty-value": "Не выбрана",
                        placeholder: "Выберите станцию метро"
                      },
                      on: { change: _vm.onChangeMetro }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c("ui-segmented", {
              staticClass: "tabs",
              attrs: { labels: ["Список", "Карта"] },
              model: {
                value: _vm.view,
                callback: function($$v) {
                  _vm.view = $$v
                },
                expression: "view"
              }
            }),
            _c("h2", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.stores.length) +
                  " " +
                  _vm._s(
                    _vm._f("decl")(_vm.stores.length, "магазин", [
                      "",
                      "а",
                      "ов"
                    ])
                  ) +
                  "\n      "
              )
            ])
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "body" },
          [
            _vm.view === "Список"
              ? _c("stores-list", { attrs: { stores: _vm.stores } })
              : _c("stores-map", {
                  staticClass: "map",
                  attrs: {
                    "active-store-id": _vm.activeStoreId,
                    "current-local-city": _vm.currentCity,
                    "popup-by-click": "",
                    stores: _vm.stores
                  },
                  on: {
                    change: function($event) {
                      _vm.activeStoreId = $event
                    }
                  }
                })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }